import {Pipe, PipeTransform} from "@angular/core";
import {Notification} from "../../api/models/notification";
import {UserRole} from "../../api/models/user-role";

export function routeOfExpectedValidationNotification(notification: Notification): string[] {
  if (
    notification.type == null ||
    !['VALIDATION_EXPECTED', 'DELIVERY_ORDER_COMPLETION_EXPECTED'].includes(notification.type)
  ) {
    throw new Error(
      `only supports notification type 'VALIDATION_EXPECTED' and 'DELIVERY_ORDER_COMPLETION_EXPECTED', received: ${notification.type}`
    );
  }

  if (notification.type === 'DELIVERY_ORDER_COMPLETION_EXPECTED') {
    return [`/purchase-order/${notification.purchaseOrder!.uuid}/complete`];
  }

  // VALIDATION_EXPECTED
  if (notification.invoiceDocument) {
    return [`/invoices/${notification.invoiceDocument.uuid}/validation`];
  }

  if (notification.purchaseOrder && notification.role) {
    return [
      `/purchase-order/${notification.purchaseOrder.uuid}/validation/${validationFromRole(notification.role)}`
    ];
  }

  throw new Error(
    `VALIDATION_EXPECTED notification must target either an invoiceDocument or a purchaseOrder with role`
  );
}

function validationFromRole(role: UserRole): string {
  if (role === "QHSE") {
    return 'green-lights'
  }
  if (role === "DIRECTOR") {
    return 'amount'
  }
  throw new Error(`Notification role is not supported : ${role}`);
}

@Pipe({
  name: 'routeOfExpectedValidationNotification',
  standalone: true
})
export class RouteExpectedValidationNotificationPipe implements PipeTransform {
  transform(notification: Notification): string[] {
    return routeOfExpectedValidationNotification(notification);
  }

}
